import { uploadWarrantStateName } from './uploadWarrant/uploadWarrant.state';
import { confirmWarrantStateName } from './confirmWarrant/confirmWarrant.state';
import { successfulConfirmStateName } from './successfulConfirm/successfulConfirm.state';

export const TransferringConfirmSuccessState = successfulConfirmStateName;

export const TransferringStates = [
  uploadWarrantStateName,
  confirmWarrantStateName
];
